export type State = {
  isExpand: boolean
}

export const state: State = {
  isExpand: true,
}
